




import Person from '@/types/Person.interface'
import Vue, { PropType } from 'vue'
import HiddenInput from '@/types/HiddenInput.interface'
import HiddenInputComponent from '@/components/HiddenInput.vue'
export default Vue.extend({
    components: { 'hidden-input': HiddenInputComponent },
    props: {
        person: {
            type: Object as PropType<Person>,
            required: true
        },
        saving: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        notes(): HiddenInput {
            return {
                name: 'Notes',
                textarea: true,
                value: this.person.notes,
                label: 'Notes',
                labelIcon: 'mdi-file-document',
                placeholder: 'Notes',
                outlined: true,
                callback: (val: string) => (this.person.notes = val)
            }
        }
    }
})
